import { defineComponent, reactive, toRefs, watch, TransitionGroup } from 'vue';
import ApplicationCategoriesService from '/blocks/common/applications/search-apps/services/application-categories-service';
import applicationIndustriesService from '/blocks/common/applications/search-apps/services/application-industries-service';
import { ApplicationCard } from '/blocks/common/applications/search-apps/components/application-card';
import { Combobox } from '/blocks/common/applications/search-apps/components/combobox';
import { debounce } from 'lodash';

export const SearchAppsApplication = defineComponent({
    name: 'App',
    props: {
        modelValue: {
            type: String,
            default: () => ''
        },
    },
    components: {
        Combobox,
        ApplicationCard,
    },
    setup(props, { emit }) {
        const state = reactive({
            applicationCategories: [],
            applicationCategoriesNames: [],
            applications: [],
            categoryValue: '',
            selectedGroup: {
                value: '',
                source: undefined
            }
        });

        const initCategories = async () => {
            try {
                const response = await ApplicationCategoriesService.getApplicationCategories();
                state.applicationCategories = response.data.categories;
                state.applicationCategoriesNames = state.applicationCategories
                    .map((applicationCategory) => applicationCategory.title);
            } catch (e) {

            }
        };


        function _getParameterByName(name, url = window.location.href) {
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);

            if (!results) {
                return null;
            }

            if (!results[2]) {
                return '';
            }

            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }

        watch(() => state.applicationCategories, async (newApplicationCategories) => {
            if (newApplicationCategories === undefined || newApplicationCategories.length === 0) {
                return;
            }

            const appsSearchParam = _getParameterByName('apps_search');
            if (appsSearchParam === null) {
                const response = await applicationIndustriesService.getFeaturedApplicationIndustries();

                if (response.data === '') {
                    state.applications = [];
                    return;
                }

                state.applications = response.data.industries;
                return;
            }

            const foundCategory = state.applicationCategories
                .find((applicationCategory) => applicationCategory.title === appsSearchParam);

            let categoryId: number = -1;
            if (foundCategory !== undefined) {
                categoryId = foundCategory.id
            }

            const response = await applicationIndustriesService.getApplicationIndustries(categoryId, appsSearchParam);
            state.applications = response.data.apps.Application;
        }, {
            immediate: true
        });

        async function onSelectedGroupChanged(newSelectedGroup) {
            if (newSelectedGroup === undefined) {
                return;
            }

            if (newSelectedGroup.value === '') {
                const response = await applicationIndustriesService.getFeaturedApplicationIndustries();

                if (response.data === '') {
                    state.applications = [];
                    return;
                }

                state.applications = response.data.industries;
                return;
            }

            const foundCategory = state.applicationCategories
                .find((applicationCategory) => applicationCategory.title === newSelectedGroup.value);

            let categoryId: number = -1;
            if (foundCategory !== undefined) {
                categoryId = foundCategory.id
            }

            const response = await applicationIndustriesService.getApplicationIndustries(categoryId, newSelectedGroup.value);
            state.applications = response.data.apps.Application;
        }

        const debounceSelectedGroupChanged = debounce(onSelectedGroupChanged, 1000);
        const debounceImSelectedGroupChanged = debounce(onSelectedGroupChanged, 0);

        watch(() => state.selectedGroup, (newSelectedGroup) => {
            if (newSelectedGroup.source && newSelectedGroup.source === 'input') {
                return debounceSelectedGroupChanged(newSelectedGroup);
            }

            return debounceImSelectedGroupChanged(newSelectedGroup);            
        });

        initCategories();

        return () => (
            <>
                <div class="search-apps__layout">
                    <Combobox
                        class="search-apps__categories-combo"
                        list={state.applicationCategoriesNames}
                        fullValue={state.selectedGroup}
                        onFullValueChange={
                            (value) => {
                                state.selectedGroup = value
                             }
                        }
                    >
                    </Combobox>
                    <div>
                        <ul class="search-apps__templates-list">
                            <TransitionGroup name="list">
                                {
                                    state.applications.map((application) => {
                                        return <ApplicationCard
                                            application={application}
                                            key={application.id}
                                        />
                                    })
                                }
                            </TransitionGroup>
                        </ul>            
                    </div>
                </div>
            </>
        )
    }
});

export type SearchAppsApplication = InstanceType<typeof SearchAppsApplication>